module.exports = __webpack_public_path__ + "img/page.657cfa91.png";